{
  "Addusertitle": "Add Application User Account",
  "Modifyusertitle": "Modify Application User Account",
  "PermissionsTitle": "Permissions",
  "ExtensionTitle": "Extension/Endpoint",
  "ReportingTitle": "Reporting",
  "AdministratorTitle": "Administrator",
  "RoleTitle": "Role",
  "SettingsTitle": "Settings",
  "APIKeys_Title": "API Keys",
  "ValidationWarning": "Please correct errors before finishing",
  "ServerErrorTitle": "Validation errors",
  "MonthlyBillingWarning": "WARNING: Affects Monthly Billing",
  "UnknownOrDeleted": "[Unknown or Deleted]",
  "NAME": "AddUserLanguage",
  "AddUserLanguage_ButtonHelpLabel": "Help?",
  "AddUserLanguage_ButtonSubmitLabel": "Save",
  "AddUserLanguage_ButtonCancelLabel": "Cancel",
  "AddUserLanguage_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
  "AddUserLanguage_PromptConfirm": "Yes",
  "AddUserLanguage_PromptCancel": "Cancel",
  "AddUserLanguage_DetailsTitle": "User Details"
}